import { render, staticRenderFns } from "./EventoCard.vue?vue&type=template&id=764a8e4c&scoped=true&"
import script from "./EventoCard.vue?vue&type=script&lang=js&"
export * from "./EventoCard.vue?vue&type=script&lang=js&"
import style0 from "./EventoCard.vue?vue&type=style&index=0&id=764a8e4c&prod&lang=css&"
import style1 from "./EventoCard.vue?vue&type=style&index=1&id=764a8e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a8e4c",
  null
  
)

export default component.exports